
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insights/state/[slug]",
      function () {
        return require("private-next-pages/insights/state/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insights/state/[slug]"])
      });
    }
  